import React from 'react';
import GenericTableEditor from '../../components/admin/GenericTableEditor';

const AwardsEditor = () => {
  const columns = [
    { key: 'title_en', label: 'Title (EN)', type: 'text' },
    { key: 'title_ms', label: 'Title (MS)', type: 'text' },
    { key: 'description_en', label: 'Description (EN)', type: 'textarea' },
    { key: 'description_ms', label: 'Description (MS)', type: 'textarea' },
    { key: 'year', label: 'Year', type: 'text' },
    { key: 'image', label: 'Image URL', type: 'image' },
  ];

  return <GenericTableEditor tableName="awards" columns={columns} title="Awards Manager" />;
};

export default AwardsEditor;
